import { IFACTURE, MoyenPaiement, StatutFacture } from 'app/shared/model/facture.model';
import { StatutSalaire } from '../shared/model/salaire.model';

export const getStatusColor = (status: StatutFacture) => (status === StatutFacture.PAYEE ? 'green' : '#1890ff');

export const getStatusColorSalaire = (status: StatutSalaire) => (status === StatutSalaire.PAYEE ? 'green' : '#1890ff');

export const getMoyenPaiementColor = (moyenPaiement: MoyenPaiement) => {
  switch (moyenPaiement) {
    case MoyenPaiement.WAVE:
      return '#1890ff';
    case MoyenPaiement.OM:
      return '#f28e19';
    default:
      return 'inherit';
  }
};
